require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-kayla-asay.json") })
        }
      }, "path---blog-author-kayla-asay");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-kayla-asay!./.cache/json/blog-author-kayla-asay.json
// module id = 667
// module chunks = 231608221292675